import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent implements OnInit {
  logoUrl: string;
  tenantName: string;
  userName: string = '';
  personId: string = '';
  constructor(
    private appConfigService: AppConfigService,
    private oidcSecurityService: OidcSecurityService
  ) {}
  ngOnInit(): void {
    this.logoUrl = this.appConfigService.tenant.logoUrl;
    this.tenantName = this.appConfigService.tenant.name;
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.userName = userData ? `${userData.given_name} ${userData.family_name}` : '';
      this.personId = userData ? userData.sub : '';
    });
  }
  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
      this.oidcSecurityService.logoffLocal();
    });
  }
  changePassword() {
    this.oidcSecurityService.getConfiguration().subscribe((config) => {
      if (config) {
        const { authority, postLogoutRedirectUri } = config;
        const returnUrl = `${postLogoutRedirectUri}/dashboard`;
        window.location.href = `${authority}/Account/ChangePassword?returnUrl=${returnUrl}`;
      }
    });
  }
}
